import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { CeContainerComponent, CeEmptyStateImports } from '@kempower-nx-workspace/shared/kp-design-system';
import { Auth0Service } from '../../data-access/auth0-service/auth0.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthQueryParams, AuthRouteData } from '../../data-access/types/auth0-types';

@Component({
    selector: 'ce-auth0-callback',
    imports: [CommonModule, CeContainerComponent, CeEmptyStateImports],
    providers: [Auth0Service, JwtHelperService],
    templateUrl: './authentication-callback.component.html'
})
export class AuthenticationCallbackComponent {
    route = inject(ActivatedRoute);
    auth0Service = inject(Auth0Service);
    callBackTitle = 'Logging you in...';

    isError = signal(false);
    callBackSite = signal<string | null>(null);

    hasError = computed(() => {
        return this.auth0Service.hasError() || this.isError();
    });

    callBackMessage = computed(() => {
        if (this.callBackSite() === null) {
            return 'Please wait while we log you in...';
        }
        return `Please wait while we log you in to ${this.callBackSite()}`;
    });

    constructor() {
        combineLatest([this.route.data, this.route.queryParams])
            .pipe(
                takeUntilDestroyed(),
                map(([data, params]) => ({ data: data as AuthRouteData, params: params as AuthQueryParams }))
            )
            .subscribe(({ data, params }) => {
                if (data['authSiteName'] !== null) {
                    this.callBackSite.set(data['authSiteName']);
                }
                if (params.code) {
                    this.auth0Service.authorizeWithCode(params.code, params.state);
                } else {
                    this.isError.set(true);
                }
            });
    }
}
